<template>
  <b-modal id="createCyclicTaskModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmcyclictask.createCyclicTaskModalHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="agreement">
      <b-col>
        <Create :agreementIRI="agreement['@id']"></Create>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import Create from '../Create.vue'
export default {
  name: 'CreateCyclicTaskModal',
  components: {
    Create
  },
  computed: {
    show () {
      return this.$store.state.modals.excmcyclictask.create.show
    },
    agreementObject () {
      return this.$store.state.modals.excmcyclictask.create.agreement
    },
    close () {
      return this.$store.state.modals.excmcyclictask.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'agreementObject': function (val) {
      this.closeModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      agreement: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.agreementObject) {
        this.agreement = Object.assign({}, this.agreementObject)
        this.$store.state.modals.excmcyclictask.create.show = 0
        this.$store.state.modals.excmcyclictask.create.agreement = null
        this.$bvModal.show('createCyclicTaskModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmcyclictask.create.close = 0
      }
      this.$bvModal.hide('createCyclicTaskModal')
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
